import { useQueryClient } from '@tanstack/react-query'

import { useIndividualsServicePatchV1IndividualsByIndividualId } from '../client/queries'
import { INDIVIDUAL_INVALIDATION_KEYS } from './regen-invalidation'

export const useUpdateIndividual = () => {
  const queryClient = useQueryClient()

  return useIndividualsServicePatchV1IndividualsByIndividualId({
    onSuccess: () => {
      for (const key of INDIVIDUAL_INVALIDATION_KEYS) {
        queryClient.invalidateQueries({ queryKey: [key] })
      }
    },
  })
}
